import { Box } from '@mui/material';
import { useOwnUserNode } from '/@/hooks/nodes';
import { getNodeScopeFilters } from '/@/utils/node-scope';
import CropDistributionDashboardCard from '../../components/crop-distribution';
import FieldsByStageDashboardCard from '../../components/fields-by-stage-dashboard-card';
import FieldsDashboardCard from '../../components/fields-count';
import GrowersDashboardCard from '../../components/growers-count';
import DashboardCardRVsCount from '../../components/rv-count';
import RVsList from '../../components/rv-list';

export const RVCurrentCampaignDashboard = () => {
    const rvUserNodeQuery = useOwnUserNode();

    return (
        <>
            {rvUserNodeQuery.data && (
                <Box sx={{ display: 'grid', gridTemplateColumns: { md: '1fr 1fr 1fr', xs: '1fr' }, gap: 3 }}>
                    <DashboardCardRVsCount />
                    <FieldsDashboardCard />
                    <Box sx={{ gridRow: 'span 2' }}>
                        <FieldsByStageDashboardCard nodeScope={getNodeScopeFilters('rvs')} />
                    </Box>

                    <GrowersDashboardCard />

                    <CropDistributionDashboardCard />
                </Box>
            )}

            {rvUserNodeQuery.data && <RVsList tab='current-campaign' />}
        </>
    );
};
